const initNavbar = () => {
    const navbar = document.querySelector(".navbar");
    const toggle = document.getElementById("navbar-toggle");
    const linkContainer = document.getElementById("navbar-links");
    const dropdowns = document.querySelectorAll(".navbar .dropdown");
    const profile = document.querySelector(".navbar-profile");
    const profileInfo = profile?.querySelector(".profile-info");

    if (!navbar || !toggle || !linkContainer) return;
    
    // Éviter la réinitialisation multiple
    if (navbar.dataset.initialized) return;
    navbar.dataset.initialized = 'true';

    // Burger mobile
    toggle.addEventListener("click", () => {
        navbar.classList.toggle("open");
    });

    // Profil (clic mobile)
    if (profile && profileInfo) {
        profileInfo.addEventListener("click", (e) => {
            e.stopPropagation();
            profile.classList.toggle("open");
        });

        document.addEventListener("click", (e) => {
            if (!profile.contains(e.target)) profile.classList.remove("open");
        });
    }

    // Helper
    const isTouch = () => window.matchMedia("(max-width: 900px)").matches;

    // Dropdowns
    dropdowns.forEach((dd) => {
        const btn = dd.querySelector(".dropdown-btn");
        if (!btn) return;

        let closeTimer = null;

        dd.addEventListener("mouseenter", () => {
            if (isTouch()) return;
            clearTimeout(closeTimer);
            dd.classList.add("open");
        });

        dd.addEventListener("mouseleave", () => {
            if (isTouch()) return;
            closeTimer = setTimeout(() => dd.classList.remove("open"), 140);
        });

        btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isTouch()) {
                dropdowns.forEach((other) => {
                    if (other !== dd) other.classList.remove("open");
                });
            }
            dd.classList.toggle("open");
        });
    });

    // Fermer tout au clic hors navbar
    document.addEventListener("click", (e) => {
        if (!navbar.contains(e.target)) {
            navbar.classList.remove("open");
            dropdowns.forEach((dd) => dd.classList.remove("open"));
            profile?.classList.remove("open");
        }
    });

    // Fermer à resize
    window.addEventListener("resize", () => {
        navbar.classList.remove("open");
        dropdowns.forEach((dd) => dd.classList.remove("open"));
        profile?.classList.remove("open");
    });
};

export { initNavbar };
